// External modules
import acHTTPClient from 'services/ACHTTPClient';
import * as moment from 'moment';

// Internal modules
import * as constants from '../constants';
import config from '../../../config/config';
import { onAuthError } from '../auth';

// TODO: Use SSM
const experienceAPIURL = `${config.experienceAPIURL}/api/v1`;

const getCluesByProviderIdError = (error) => {
  return {
    type: constants.GET_CLUES_BY_PROVIDER_ID_ERROR,
    error,
  };
};
const getCluesErrored = (error) => {
  return {
    type: constants.GET_CLUES_ERROR,
    error,
  };
};

const getCluesByProviderIdSuccess = (clues) => {
  return {
    type: constants.GET_CLUES_BY_PROVIDER_ID_SUCCESS,
    clues: clues,
  };
};

const getCluesSuccess = (clues) => {
  return {
    type: constants.GET_CLUES_SUCCESS,
    clues: clues,
  };
};

const getCluesByProviderId = (providerId) => {
  let apiURL = `${experienceAPIURL}/providers/${providerId}/clues`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(getCluesByProviderIdError(response.statusText));
        }
        dispatch(getCluesByProviderIdSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getCluesByProviderIdError(error));
      });
  };
};

const getClues = () => {
  let apiURL = `${experienceAPIURL}/clues`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(getCluesErrored(response.statusText));
        }
        dispatch(getCluesSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getCluesErrored(error));
      });
  };
};

const postClueError = (error) => {
  return {
    type: constants.POST_CLUE_ERROR,
    error,
  };
};

const postClueSuccess = (newId) => {
  return {
    type: constants.POST_CLUE_SUCCESS,
    newId: newId,
  };
};

const postClue = (newClue) => {
  let apiURL = `${experienceAPIURL}/clues`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'POST', data: newClue };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(postClueError(response.statusText));
        }
        dispatch(postClueSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(postClueError(error));
      });
  };
};

const postClues = async (clues) => {
  const promiseArray = [];
  let apiURL = `${experienceAPIURL}/clues`;
  clues.forEach(clue => {
    promiseArray.push(new Promise((resolve, reject) => {
      const config = { url: apiURL, method: 'POST', data: clue };
      acHTTPClient.request(config)
        .then(response => {
          return resolve(response.data);
        })
        .catch(error => {
          return reject(error);
        });
    }));
  });
  return await Promise.all(promiseArray).then(res => {
    return res;
  });
}

const patchClueError = (error) => {
  return {
    type: constants.PATCH_ITEM_ERROR,
    error,
  };
};

const patchClueSuccess = (clue) => {
  return {
    type: constants.PATCH_CLUE_SUCCESS,
    clue: clue,
  };
};

const patchClue = (clue) => {
  let apiURL = `${experienceAPIURL}/clues/${clue.id}`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'PATCH', data: clue };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(patchClueError(response.statusText));
        }
        dispatch(patchClueSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(patchClueError(error));
      });
  };
};

const uploadClueSuccess = (clues) => {
  return {
    type: constants.UPLOAD_CLUE_SUCCESS,
    clues,
  };
};

const uploadClueError = (error) => {
  return {
    type: constants.UPLOAD_CLUE_ERROR,
    error,
  };
};

const uploadClue = (fileList) => {
  return async function (dispatch) {
    try {
      // console.log(fileList);
      const file = fileList[0];
      let fileExt = file.name.split('.').pop();

      // Replacing the file name to a custom one to avoid SQL Injections
      let fileName = `amazingco-clue-${Math.random().toString(36).substr(4)}-${moment().format('YYYY-MM-DD-HH-mm-ss')}.${fileExt}`;
      let apiURL = `${experienceAPIURL}/clues/upload?name=${fileName}`;
      const config = {
        url: apiURL,
        method: 'POST',
        headers: {
          'Content-Type': 'application/octet-stream',
        },
        data: file,
      };
      acHTTPClient
        .request(config)
        .then((response) => {
          if (!response.data || response.data.error) {
            dispatch(uploadClueError(response.statusText));
          }
          const data = {
            uploadData: response.data.data,
          };
          dispatch(uploadClueSuccess(data));
        })
        .catch((error) => {
          onAuthError(error);
          dispatch(uploadClueError(error));
        });
    } catch (error) {
      onAuthError(error);
      let errObj = error;
      // map it to error object
      if (typeof errObj === 'string') {
        errObj = new Error(errObj);
      }
      return dispatch(uploadClueError(errObj));
    }
  };
};

const getCluesBySparkIdError = (error) => {
  return {
    type: constants.GET_CLUES_BY_SPARK_ID_ERROR,
    error,
  };
};

const getCluesBySparkIdSuccess = (clues) => {
  return {
    type: constants.GET_CLUES_BY_SPARK_ID_SUCCESS,
    clues: clues,
  };
};
const getCluesBySparkId = (sparkId) => {
  let apiURL = `${experienceAPIURL}/sparks/${sparkId}/clues`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(getCluesBySparkIdError(response.statusText));
        }
        dispatch(getCluesBySparkIdSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getCluesBySparkIdError(error));
      });
  };
};

export { getCluesByProviderId, getClues, getCluesBySparkId, postClue, postClues, patchClue, uploadClue };
